// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1KMm3","bigColWidth":"Table_bigColWidth__1C5nT","biggerColWidth":"Table_biggerColWidth__OEZsg","row":"Table_row__1zCtC","col":"Table_col__1f74o"};